import { render } from "./SaferWorld.vue?vue&type=template&id=b5dfa8c4"
import script from "./SaferWorld.vue?vue&type=script&lang=js"
export * from "./SaferWorld.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__